export default __webpack_public_path__ + "assets/images/8cf51d508702089b2d1863a6f4cb261c.svg";